/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;



// WEBPACK FOOTER //
// ./~/lodash/internal/realNames.js